/**
 * Confirm
 */

import Config from "./Config";
import Util from "./Util";
import Template from "./board/Template";

let INSTANCE: Dialog;

class Dialog {
  private id: any;

  private msg: any;

  private resolve: any;

  private reject: any;

  private hidden: any;

  private isOpened: boolean = false;

  private temp: any;

  constructor(data: any, resolve: any, reject: any, hidden?: any) {
    this.id = data.id;
    this.msg = data.msg;
    this.resolve = typeof resolve === "function" ? resolve : null;
    this.reject = typeof reject === "function" ? reject : null;
    this.hidden = typeof hidden === "function" ? hidden : null;
    this.temp = Template.dialog(data);

    jQuery("body").append(this.temp);
    this.addEvents();
  }

  public show() {
    jQuery(`#${this.id}.ui-dialog`).addClass("is-show");
    this.isOpened = true;
  }

  public hide() {
    if (this.isOpened) {
      jQuery(`#${this.id}.ui-dialog`).removeClass("is-show");
      this.isOpened = false;
    }
  }

  private ok(evt: any) {
    return this.resolve(evt);
  }

  private cancel(evt: any) {
    return this.reject(evt);
  }

  private close(evt: any) {
    this.hide();
    if (this.hidden !== null) return this.hidden(evt);
  }

  private addEvents() {
    const _dialog = `#${this.id}.ui-dialog`;
    jQuery("body").on("click", `${_dialog} .co-btn-ok`, evt => {
      this.ok(evt);
    });

    jQuery("body").on("click", `${_dialog} .co-btn-cancel`, evt => {
      this.cancel(evt);
    });

    jQuery("body").on("click", '.ui-dialog-overlay', () => {
      this.hide();
    });

    jQuery("body").on("click", '.ui-dialog-close', (evt) => {
      if ( this.hidden !== null) {
        this.close(evt);
      } else {
        this.hide();
      }
    });

    jQuery("body").on("keyup", evt => {
      if (!this.isOpened) {
        return;
      }

      const _keyCode = evt.keyCode ? evt.keyCode : evt.which;
      if (_keyCode === 27) {
        this.hide();
      }
    });
  }
}

export default Dialog;
